import { useCallback, useMemo } from "react";
import { useTranslation } from "../hooks";
import { convertTagNameToId } from "../utils";
// eslint-disable-next-line max-lines-per-function -- exhaustive tag map with literal translate("common:tags.…") per TagId for grep / i18n extractors
export default function useTranslatedTag() {
    const { t } = useTranslation();
    const translatedByTagId = useMemo(() => ({
        nsfw: t("common:tags.nsfw"),
        female: t("common:tags.female"),
        male: t("common:tags.male"),
        action: t("common:tags.action"),
        adventure: t("common:tags.adventure"),
        agePlay: t("common:tags.agePlay"),
        aiAssistant: t("common:tags.aiAssistant"),
        anal: t("common:tags.anal"),
        anime: t("common:tags.anime"),
        anthro: t("common:tags.anthro"),
        bondage: t("common:tags.bondage"),
        cheating: t("common:tags.cheating"),
        chubby: t("common:tags.chubby"),
        cnc: t("common:tags.cnc"),
        comedy: t("common:tags.comedy"),
        corruption: t("common:tags.corruption"),
        crossdressing: t("common:tags.crossdressing"),
        dominant: t("common:tags.dominant"),
        drama: t("common:tags.drama"),
        english: t("common:tags.english"),
        fantasy: t("common:tags.fantasy"),
        fat: t("common:tags.fat"),
        feet: t("common:tags.feet"),
        femalePov: t("common:tags.femalePov"),
        femboy: t("common:tags.femboy"),
        fictionalMedia: t("common:tags.fictionalMedia"),
        flatulence: t("common:tags.flatulence"),
        friend: t("common:tags.friend"),
        furry: t("common:tags.furry"),
        futanari: t("common:tags.futanari"),
        game: t("common:tags.game"),
        gentleDom: t("common:tags.gentleDom"),
        giant: t("common:tags.giant"),
        gothic: t("common:tags.gothic"),
        hero: t("common:tags.hero"),
        historical: t("common:tags.historical"),
        horror: t("common:tags.horror"),
        impregnation: t("common:tags.impregnation"),
        inanimate: t("common:tags.inanimate"),
        inflation: t("common:tags.inflation"),
        lactation: t("common:tags.lactation"),
        lgbtqPlus: t("common:tags.lgbtqPlus"),
        lowQuality: t("common:tags.lowQuality"),
        magic: t("common:tags.magic"),
        malePov: t("common:tags.malePov"),
        marriedPartner: t("common:tags.marriedPartner"),
        masochistic: t("common:tags.masochistic"),
        mature: t("common:tags.mature"),
        milf: t("common:tags.milf"),
        mindControl: t("common:tags.mindControl"),
        mlm: t("common:tags.mlm"),
        monster: t("common:tags.monster"),
        multipleCharacters: t("common:tags.multipleCharacters"),
        muscle: t("common:tags.muscle"),
        mystery: t("common:tags.mystery"),
        mythological: t("common:tags.mythological"),
        nature: t("common:tags.nature"),
        nonBinary: t("common:tags.nonBinary"),
        nonEnglish: t("common:tags.nonEnglish"),
        ntr: t("common:tags.ntr"),
        omegaverse: t("common:tags.omegaverse"),
        oral: t("common:tags.oral"),
        originalCharacter: t("common:tags.originalCharacter"),
        partner: t("common:tags.partner"),
        pregnant: t("common:tags.pregnant"),
        real: t("common:tags.real"),
        romantic: t("common:tags.romantic"),
        roommate: t("common:tags.roommate"),
        rpg: t("common:tags.rpg"),
        sadistic: t("common:tags.sadistic"),
        scenario: t("common:tags.scenario"),
        sciFi: t("common:tags.sciFi"),
        servant: t("common:tags.servant"),
        simulator: t("common:tags.simulator"),
        sizeDifference: t("common:tags.sizeDifference"),
        slave: t("common:tags.slave"),
        smell: t("common:tags.smell"),
        specifiedPov: t("common:tags.specifiedPov"),
        stepFamily: t("common:tags.stepFamily"),
        submissive: t("common:tags.submissive"),
        supernatural: t("common:tags.supernatural"),
        switch: t("common:tags.switch"),
        tomboy: t("common:tags.tomboy"),
        trans: t("common:tags.trans"),
        transformation: t("common:tags.transformation"),
        tsundere: t("common:tags.tsundere"),
        villain: t("common:tags.villain"),
        vore: t("common:tags.vore"),
        watersport: t("common:tags.watersport"),
        wholesome: t("common:tags.wholesome"),
        wlw: t("common:tags.wlw"),
        yandere: t("common:tags.yandere"),
    }), [t]);
    const getTranslatedTag = useCallback((name) => {
        if (!name)
            return "";
        const id = convertTagNameToId(name);
        return translatedByTagId[id] ?? name;
    }, [translatedByTagId]);
    return { getTranslatedTag };
}
